import React from "react";
import { Box, Typography } from "@mui/material";
import PaynamicsImg1 from "../../assets/paynamics/PaynamicsImg1";

const PaynamicsSuccessPagePremium: React.FC = () => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "20px",
      }}
    >
      <PaynamicsImg1 />
      <Box
        sx={{
          width: "75%",
          textAlign: "center",
          marginTop: "15px",
          marginX: "auto",
        }}
      >
        <Typography variant="h4">Finishing your Transaction</Typography>
        <br />
        <Typography variant="subtitle1">
          We're preparing to send the e-policy/certificate of insurance to your
          email. If you've received a payment confirmation but the e-policy
          email hasn't landed in your inbox, please visit your Quotation List on
          the Home Page. Status should be "For Policy Issuance". Expect to
          receive the e-policy within 1 hour, or you may email cxc@malayan.com
          for assistance.
        </Typography>
      </Box>
    </Box>
  );
};

export default PaynamicsSuccessPagePremium;
